import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { jwtDecode } from "jwt-decode";
import { firstValueFrom } from 'rxjs';
import { LoggerService } from '../_services/logger.service';
import { IndexedDbService } from '../_services/indexed-db.service';
import { GlobalService } from '../_services/global.service'; // Importar GlobalService

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private loggerService: LoggerService,
        private db: IndexedDbService,
        private globalService: GlobalService // Injetar GlobalService
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        this.loggerService.info('AuthGuard#canActivate called');
        const token = await this.db.getData('id_token');
        if (!token) {
            this.loggerService.info('No token found, redirecting to login');
            return this.router.createUrlTree(['/login']);
        }

        try {
            const decoded: any = jwtDecode(token);
            const now = Math.floor(Date.now() / 1000);

            if (decoded.exp && decoded.exp < now) {
                try {
                    await firstValueFrom(this.authService.refreshTokenRequest());
                } catch (err) {
                    this.loggerService.error('Token refresh failed', err);
                    return this.router.createUrlTree(['/login']);
                }
            }

            // Lógica de verificação de role
            const requiredRoles = route.data['roles'] as string[];

            if(requiredRoles === undefined || requiredRoles.length === 0) {
                return true; // Nenhuma role específica exigida, permitir acesso
            }

            if (requiredRoles && (requiredRoles.includes('admin') || requiredRoles.includes('admin_grupo') || requiredRoles.includes('admin_global_grupo')))
            {
                
                const isAdmin = this.globalService.isAdmin();
                const isAdminGrupo = this.globalService.isAdminGrupo();
                const isAdminGlobalGrupo = this.globalService.isAdminGlobalGrupo();    
                
                var routGrupos = route.url[0]["path"] === 'grupo-lista' || route.url[0]["path"] === 'grupo-detalhe' || route.url[0]["path"] === 'grupo-usuarios' ;
                var routPerformance = route.url[0]["path"] === 'performance' ;   
                if (routGrupos || routPerformance) {       
                    if (!(isAdmin || isAdminGrupo || isAdminGlobalGrupo)) {
                        this.loggerService.warn('User is not admin or group admin, redirecting to home');
                        return this.router.createUrlTree(['/']);
                    }   
                } else {
                    if (!isAdmin) {
                        this.loggerService.warn('User is not admin, redirecting to home');
                        return this.router.createUrlTree(['/']);
                    }
                }
            }

            return true;
        } catch (e) {
            this.loggerService.error("Erro ao decodificar token", e);
            return this.router.createUrlTree(['/login']);
        }
    }
}